const magicQueryKeys = {
  suggestions: (context) => [
    "magic-suggestions",
    context
  ]
};

export { magicQueryKeys };
//# sourceMappingURL=magicQueries.js.map
